import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ModalDocument extends Component {
  render() {
    // Render nothing if the "show" prop is false
    if (!this.props.show) {
      return null;
    }

    // The gray background
    const backdropStyle = {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'rgba(0,0,0,0.8)',
      padding: 50,
      zIndex: 99
    };

    // The modal "window"
    const modalStyle = {
      position: 'relative',
      backgroundColor: '#fff',
      borderRadius: 5,
      maxWidth: 1200,
      minHeight: 800,
      margin: '0 auto',
      padding: 10,
      zIndex: 999
    };

    return (
      <div className="backdrop-pdf" style={backdropStyle}>
        <div className="modal-pdf" style={modalStyle}>
          <button onClick={this.props.onClose} className="btn btn-info">
            Close
          </button>
          {this.props.children}
          <div className="footer">
            <button onClick={this.props.onClose} className="btn btn-info">
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }
}

ModalDocument.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  children: PropTypes.node
};

export default ModalDocument;
